export const vertical = {
  margin: 0,
  padding: 0,
};

export const horizontal = {
  margin: 0,
  padding: 0,
};

export default {
  horizontal,
  vertical,
};
